import {
  SYNC_CONCURRENCY_HELP,
  type DecisionEngineDestinationDefinition,
} from "./definition";
import {
  getMappingForUserColumn,
  hightouchPayloadMapping,
} from "./sync-config-helpers";

const ACC_ADDRESS_FIELD: Record<string, string> = {
  email: "Email",
  sms: "Telephone",
};

export const accDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "adobe-campaign-classic",
  category: "batch",
  generateSyncConfig: ({
    producer,
    channelType,
    settings,
    isPreview,
    messageTags,
  }) => {
    const { channelDataColumn, customResourceName } = settings;
    const addressField = ACC_ADDRESS_FIELD[channelType] ?? "Email";

    if (!customResourceName) {
      throw new Error(
        "customResourceName is required in channel config for ACC object syncs",
      );
    }

    return {
      type: "object",
      object: "customResources",
      mode: "upsert",
      customResourceName,
      externalIdMapping:
        // During preview, the user-entered address is in external_id.
        // During real sends, pull it from the configured user column.
        isPreview || !channelDataColumn
          ? { from: "external_id", to: addressField }
          : getMappingForUserColumn(
              channelDataColumn.toLowerCase(),
              addressField,
            ),
      mappings: [hightouchPayloadMapping({ producer, messageTags })],
    };
  },
  // The custom-resources sync reads `parallelization` at runtime (its
  // checkpoint batch is 100 * parallelization); no batch-size key exists, so
  // batch size is not tunable.
  syncTuning: {
    modes: {
      label: "Write mode",
      description:
        "Choose whether to create custom-resource records, update existing records, or do both.",
      options: [
        { value: "insert", label: "Insert" },
        { value: "update", label: "Update" },
        { value: "upsert", label: "Upsert" },
      ],
    },
    parallelization: {
      max: 100,
      label: "Concurrent record operations",
      description:
        "Custom-resource records processed at the same time. An upsert may update a record or create it if missing.",
      help: SYNC_CONCURRENCY_HELP,
    },
  },
};
